var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera-01",
    clipPath: "url(#clip0_3298_20876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.16797 4.88655C1.16797 4.6822 1.16797 4.58002 1.1765 4.49396C1.25874 3.66391 1.91538 3.00727 2.74543 2.92503C2.83149 2.9165 2.93918 2.9165 3.15456 2.9165C3.23755 2.9165 3.27905 2.9165 3.31428 2.91437C3.76416 2.88712 4.15811 2.60318 4.32622 2.185C4.33939 2.15225 4.35169 2.11534 4.3763 2.0415C4.40091 1.96767 4.41322 1.93075 4.42638 1.898C4.5945 1.47983 4.98845 1.19588 5.43833 1.16864C5.47356 1.1665 5.51247 1.1665 5.5903 1.1665H8.4123C8.49013 1.1665 8.52905 1.1665 8.56428 1.16864C9.01416 1.19588 9.40811 1.47983 9.57622 1.898C9.58938 1.93075 9.60169 1.96767 9.6263 2.0415C9.65091 2.11534 9.66322 2.15225 9.67638 2.185C9.8445 2.60318 10.2384 2.88712 10.6883 2.91437C10.7236 2.9165 10.7651 2.9165 10.848 2.9165C11.0634 2.9165 11.1711 2.9165 11.2572 2.92503C12.0872 3.00727 12.7439 3.66391 12.8261 4.49396C12.8346 4.58002 12.8346 4.6822 12.8346 4.88655V9.44984C12.8346 10.4299 12.8346 10.92 12.6439 11.2943C12.4761 11.6236 12.2084 11.8913 11.8791 12.0591C11.5048 12.2498 11.0147 12.2498 10.0346 12.2498H3.96797C2.98788 12.2498 2.49783 12.2498 2.12349 12.0591C1.7942 11.8913 1.52649 11.6236 1.35871 11.2943C1.16797 10.92 1.16797 10.4299 1.16797 9.44984V4.88655Z",
    stroke: "#1E1A21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0013 9.62484C8.28997 9.62484 9.33464 8.58017 9.33464 7.2915C9.33464 6.00284 8.28997 4.95817 7.0013 4.95817C5.71264 4.95817 4.66797 6.00284 4.66797 7.2915C4.66797 8.58017 5.71264 9.62484 7.0013 9.62484Z",
    stroke: "#1E1A21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3298_20876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera01);
export default __webpack_public_path__ + "static/media/camera-01.cccdcded700dc351a6bb490dc04bf420.svg";
export { ForwardRef as ReactComponent };